import { createContext } from "react";
import { PaymentInfo } from "../lib/types";

const PaymentInfoContext = createContext<PaymentInfo>({});

export default PaymentInfoContext
